(function () {
  function commonValidateTime(key, minutes) {
    const cacheTime = localStorage.getItem(key);
    if (cacheTime) {
      const curTime = new Date().getTime();
      const timeDiff = curTime - Number(cacheTime);
      if (timeDiff < 1000 * 60 * minutes) {
        return false;
      }
    }
    return true;
  }
  async function commonResponse(url, config, key = '') {
    try {
      const curDomainName = window.location.hostname.includes('test') ? 'dev-gw-mall' : 'mall-shopify-cron';
      const curUrl = `https://${curDomainName}.aqara.com/openapi/${url}`
      const response = await fetch(curUrl, {...config});
      const content = await response.json();
      if (!response.ok || content.code !== 200) {
        console.error("Login failed: ", content.note);
        return;
      }
      if (key) {
        localStorage.setItem(key, new Date().getTime());
      }
      // document.body.style.display = "none";
      window.location.replace(content.data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error during login call: ", error);
    }
  }

  function fetchSignInfo() {
    return new Promise((resolve, reject) => {
      window.appCallback = function (result) {
        if (result) {
          resolve(result);
        } else {
          reject(new Error("Failed to fetch sign info from native app"));
        }
      };
      window.titleCallback = function (result) {
        if (result) {
          // eslint-disable-next-line no-console
          console.log("Title callback result:", result);
        } else {
          reject(new Error("Failed to hide title bar"));
        }
      };

      try {
        window.lmApp.CallNative(
          JSON.stringify({
            MethodName: "fetchSignInfo",
            Parameters: { jsCallBack: "appCallback" },
          })
        );
        window.lmApp.CallNative(
          JSON.stringify({
            MethodName: "hideTitle",
            Parameters: { jsCallBack: "titleCallback", hideTitleBar: "1" },
          })
        );
      } catch (error) {
        reject(new Error("Native call failed: " + error.message));
      }
    });
  }
  async function handleNativeCall() {
    try {
      const result = await fetchSignInfo();
      // eslint-disable-next-line no-console
      console.log("Native call result:", result);
      // 在结果返回后执行后续逻辑
      if (!result) {
        console.error("Get Token failed:", content.note);
        return;
      }
      // 把获取到的信息，传递给后端校验登录
      const { origin, pathname } = window.location;
      const pathParam = encodeURIComponent(`${origin}${pathname}`);
      const queryParams = {authToken: result, pathname: pathParam};
      const url = `shopify/authentic/getShopifyToken`;
      const config = {
        method: "POST",
        headers: {
          "Origin":"https://us.aqara.com",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(queryParams),
      }
      commonResponse(url, config, 'loginFromAqaraAppTime');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error during native call:", error);
    }
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return undefined;
  }
  function isLogin() {
    const userLink = document.querySelector('.header__desktop__button .nav-dropdown a');
    if (userLink && userLink.textContent.includes('Out')) {
      return true;
    }
    return false;
  }
  function validateLoginStatus() {
    const userId = getCookie('Userid');
    if (!userId) {
      return false;
    }
    if (isLogin()) {
      return false;
    }
    return true;
  }
  function handleForumDomainLogin() {
    const url = 'shopify/authentic/getShopifyViaToken';
    const { origin, pathname } = window.location;
    const pathParam = encodeURIComponent(`${origin}${pathname}`);
    const urlWithParams = `${url}?pathname=${pathParam}`;
    const config = {
      method: 'GET',
      credentials: "include"
    }
    commonResponse(urlWithParams, config, 'loginFromAqaraForumTime');
  }


  const queryParams = {};
  if (window.location.search.length) {
    new URLSearchParams(window.location.search).forEach((value,key)=>{
      queryParams[key] = value;
    })
  }
  if (queryParams.type === 'app' && window.lmApp) { // app登录
    if (!commonValidateTime('loginFromAqaraAppTime', 10)) {
      return;
    }
    handleNativeCall()
  } else { // Forum登录
    if (!commonValidateTime('loginFromAqaraForumTime', 120)) {
      return;
    }
    if (!validateLoginStatus()) {
      return;
    }
    handleForumDomainLogin()
  }
  
})();
    